import { useEffect, useState } from "react";
import { defaultAxiosInstance } from "../api/defaultInstance";
import "../css/AdProductWrite.css";
import Layout from "./Layout";
// useUser 훅을 사용하여 로그인 정보를 가져온다고 가정합니다.
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

function AdProductWrite() {
  const navigate = useNavigate();
  const location = useLocation();
  const { metaProduct } = location.state || { metaProduct: "reward" };
  const { userInfo } = useUser();

  // news_release 카테고리 옵션
  const [categoryOptions, setCategoryOptions] = useState([]);
  // news_release 카테고리-금액 리스트
  const [categoryPrices, setCategoryPrices] = useState([
    { categoryId: "", price: "" },
  ]);
  // 대필 여부
  const [isGhostwriting, setIsGhostwriting] = useState("0");
  // 송출 매체
  const [exposureMedia, setExposureMedia] = useState([]);

  const [formData, setFormData] = useState({
    advertiserName: "",
    adName: "",
    productType: "",
    writerId: userInfo.userId,
    adDescription: "",
    price: "",
    unit: "",
    averageClicks: "",
    exposureMedia: "",
    exposurePosition: "",
    minQuantity: "",
    minPeriod: "",
    maxPeriod: "",
    adProductMetaId: "",
    mediaName: "",
    mediaUrl: "",
  });

  // 메타 상품 ID 조회
  useEffect(() => {
    const fetchMetaProductId = async () => {
      try {
        const response = await defaultAxiosInstance.get(
          "/advertisement/admin/metaProduct",
          {
            params: { type: metaProduct },
          },
        );
        if (response.data.status === 200) {
          setFormData((prev) => ({
            ...prev,
            adProductMetaId: response.data.data.adProductMetaId,
          }));
        }
      } catch (error) {
        console.error("메타 상품 ID 조회 오류:", error);
        alert("메타 상품 ID 조회 오류가 발생했습니다.");
      }
    };

    fetchMetaProductId();
  }, [metaProduct]);

  // news_release 카테고리 리스트 조회
  useEffect(() => {
    if (metaProduct === "news_release") {
      defaultAxiosInstance
        .get("/advertisement/admin/newsRelease/categories")
        .then((res) => {
          setCategoryOptions(res.data.data || []);
        });
    }
  }, [metaProduct]);

  // 카테고리 행 추가
  const handleAddCategory = () => {
    setCategoryPrices([...categoryPrices, { categoryId: "", price: "" }]);
  };
  // 카테고리 행 삭제
  const handleRemoveCategory = (idx) => {
    setCategoryPrices(categoryPrices.filter((_, i) => i !== idx));
  };
  // 카테고리/금액 변경
  const handleCategoryPriceChange = (idx, field, value) => {
    setCategoryPrices(
      categoryPrices.map((row, i) =>
        i === idx ? { ...row, [field]: value } : row,
      ),
    );
  };
  // 대필 여부
  const handleGhostwritingChange = (e) => {
    setIsGhostwriting(e.target.value);
  };
  // 송출 매체 체크박스
  const handleExposureMediaChange = (media) => {
    setExposureMedia((prev) =>
      prev.includes(media) ? prev.filter((m) => m !== media) : [...prev, media],
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.adProductMetaId) {
      alert("메타 상품 ID가 없습니다. 다시 시도해주세요.");
      return;
    }

    console.log(formData);

    // 시작 금액: 카테고리별 금액 중 가장 낮은 값
    const startPrice = Math.min(
      ...categoryPrices.map((cp) => Number(cp.price)),
    );

    const payload = {
      mediaName: formData.mediaName || "",
      mediaUrl: formData.mediaUrl || "",
      adName: formData.adName || "",
      adDescription: formData.adDescription || "",
      advertiserName: formData.advertiserName || "",
      isGhostwriting: Number(isGhostwriting),
      exposureMedia: exposureMedia ? exposureMedia : formData.exposureMedia,
      exposurePosition: formData.exposurePosition
        ? formData.exposurePosition.split(",")
        : [],
      unit: formData.unit || "건",
      productType: formData.productType || "",
      startPrice,
      categoryPrices, // [{categoryId, price}]
      adProductMetaId: Number(formData.adProductMetaId),
      writerId: userInfo.userId,
      price: Number(formData.price),
      minQuantity: Number(formData.minQuantity),
      minPeriod: Number(formData.minPeriod),
      maxPeriod: Number(formData.maxPeriod),
    };

    try {
      console.log(payload);
      const response = await defaultAxiosInstance.post(
        "/advertisement/admin/product",
        payload,
      );
      if (response.data.status === 200) {
        alert(response.data.message);
        setFormData({
          advertiserName: "",
          adName: "",
          productType: "",
          writerId: userInfo.userId,
          adDescription: "",
          price: "",
          exposureMedia: "",
          adProductMetaId: "",
          mediaName: "",
          mediaUrl: "",
        });
        navigate("/ads/products");
      } else {
        alert("저장에 실패하였습니다.");
      }
    } catch (error) {
      console.error("광고 상품 저장 오류:", error);
      alert("광고 상품 저장 오류가 발생했습니다.");
    }
  };

  const renderFormFields = () => {
    switch (metaProduct) {
      case "reward":
        return (
          <>
            <div className="form-group">
              <label>시행사</label>
              <select
                name="advertiserName"
                value={formData.advertiserName}
                onChange={handleChange}
                required
              >
                <option value="">선택</option>
                <option value="버즈빌">버즈빌</option>
                <option value="호올스">호올스</option>
                <option value="토스">토스</option>
                <option value="멘토스">멘토스</option>
                <option value="길찾기">길찾기</option>
                <option value="당근">당근</option>
                <option value="베이직">베이직</option>
                <option value="브라보">브라보</option>
                <option value="찰리">찰리</option>
                <option value="제주">제주</option>
                <option value="투플">투플</option>
                <option value="홈런볼">기프트</option>
                <option value="최적화">최적화</option>
                <option value="핫팩">핫팩</option>
                <option value="카카오">카카오</option>
                <option value="일키 트래픽">일키 트래픽</option>
                <option value="썬데이">썬데이</option>
                <option value="백링크">백링크</option>
                <option value="N4">N4</option>
                <option value="화이트">화이트</option>
              </select>
            </div>
            <div className="form-group">
              <label>광고 상품명</label>
              <input
                type="text"
                name="adName"
                value={formData.adName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>상품 유형</label>
              <select
                name="productType"
                value={formData.productType}
                onChange={handleChange}
                required
              >
                <option value="">선택</option>
                <option value="유입">유입</option>
                <option value="저장">저장</option>
                <option value="저장+유입">저장+유입</option>
              </select>
            </div>
            <div className="form-group">
              <label>평균 클릭 수</label>
              <input
                type="number"
                name="averageClicks"
                value={formData.averageClicks}
                onChange={handleChange}
              />
            </div>
            <div className="form-group full-width">
              <label>광고 설명</label>
              <textarea
                name="adDescription"
                value={formData.adDescription}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>가격</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>단위</label>
              <select
                name="unit"
                value={formData.unit}
                onChange={handleChange}
                required
              >
                <option value="">선택</option>
                <option value="건">건</option>
                <option value="월">월</option>
                <option value="년">년</option>
              </select>
            </div>
            <div className="form-group">
              <label>노출 매체 (쉼표로 구분)</label>
              <input
                type="text"
                name="exposureMedia"
                value={formData.exposureMedia}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>노출 구좌 (쉼표로 구분)</label>
              <input
                type="text"
                name="exposurePosition"
                value={formData.exposurePosition}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>최소 기간</label>
              <input
                type="number"
                name="minPeriod"
                value={formData.minPeriod}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>최대 기간</label>
              <input
                type="number"
                name="maxPeriod"
                value={formData.maxPeriod}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>최소 수량</label>
              <input
                type="number"
                name="minQuantity"
                value={formData.minQuantity}
                onChange={handleChange}
                required
              />
            </div>
          </>
        );
      case "review_delete":
      case "blog_press_corps":
      case "news_release":
        return (
          <>
            <div className="form-group">
              <label>광고 상품명</label>
              <input
                type="text"
                name="adName"
                value={formData.adName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group full-width">
              <label>광고 설명</label>
              <textarea
                name="adDescription"
                value={formData.adDescription}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>가격</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>단위</label>
              <select
                name="unit"
                value={formData.unit}
                onChange={handleChange}
                required
              >
                <option value="">선택</option>
                <option value="건">건</option>
                <option value="월">월</option>
                <option value="년">년</option>
              </select>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Layout>
      <div className="ad-product-write-container">
        <h2>광고 상품 등록</h2>
        <form className="ad-product-write-form" onSubmit={handleSubmit}>
          {metaProduct === "news_release" ? (
            <>
              <div className="form-group">
                <label>언론사 명</label>
                <input
                  type="text"
                  name="mediaName"
                  value={formData.mediaName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>언론사 URL</label>
                <input
                  type="text"
                  name="mediaUrl"
                  value={formData.mediaUrl}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>카테고리 리스트</label>
                {categoryPrices.map((row, idx) => (
                  <div
                    key={idx}
                    className="category-price-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 4,
                    }}
                  >
                    <select
                      value={row.categoryId}
                      onChange={(e) =>
                        handleCategoryPriceChange(
                          idx,
                          "categoryId",
                          e.target.value,
                        )
                      }
                      required
                    >
                      <option value="">카테고리 선택</option>
                      {categoryOptions.map((opt) => (
                        <option key={opt.categoryId} value={opt.categoryId}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="number"
                      value={row.price}
                      onChange={(e) =>
                        handleCategoryPriceChange(idx, "price", e.target.value)
                      }
                      placeholder="금액"
                      required
                      style={{ marginLeft: 8, width: 100 }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveCategory(idx)}
                      style={{ marginLeft: 8 }}
                    >
                      -
                    </button>
                  </div>
                ))}
                <button type="button" onClick={handleAddCategory}>
                  +
                </button>
              </div>
              <div className="form-group">
                <label>대필 여부</label>
                <select
                  value={isGhostwriting}
                  onChange={handleGhostwritingChange}
                  required
                >
                  <option value="0">불가능</option>
                  <option value="1">가능</option>
                </select>
              </div>
              <div className="form-group">
                <label>송출 매체</label>
                <label style={{ marginRight: 8 }}>
                  <input
                    type="checkbox"
                    checked={exposureMedia.includes("네이버")}
                    onChange={() => handleExposureMediaChange("네이버")}
                  />{" "}
                  네이버
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={exposureMedia.includes("다음")}
                    onChange={() => handleExposureMediaChange("다음")}
                  />{" "}
                  다음
                </label>
              </div>
              <div className="form-group">
                <label>시작 금액</label>
                <input
                  type="number"
                  value={
                    categoryPrices.length > 0
                      ? Math.min(
                          ...categoryPrices.map((cp) => Number(cp.price) || 0),
                        )
                      : 0
                  }
                  readOnly
                />
              </div>
            </>
          ) : (
            renderFormFields()
          )}
          <div className="form-group submit-group">
            <button type="submit">저장하기</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}

export default AdProductWrite;
